import { Box, Toolbar, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";

import { useLocation } from "react-router";
import {
	getProductLogs,
	getScraperReportCards,
} from "../../../apis/scraper_logs";
import { ProductLogsTable } from "../components/ProductLogsTable";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import { useStyles } from "tss-react/mui";

function ProductLogs() {
	const { classes } = useStyles();
	const location = useLocation();
	const scraperId = location.state?.scraperId;
	const scraper_run_id = location.state?.scraper_run_id;

	// --- Server-side pagination & table state ---
	const [logs, setLogs] = useState([]);
	const [count, setCount] = useState(0); // total rows from API
	const [page, setPage] = useState(0); // 0-based page for MUIDataTable
	const [rowsCount, setRowsCount] = useState(25); // rows per page
	const [loading, setLoading] = useState(false);

	const [value, setValue] = useState("1"); // Tab state
	const [actionFilter, setActionFilter] = useState("updated");
	const [percentageData, setPercentageData] = useState(null);

	// --- Load product logs whenever filter, page, rowsCount or scraperId changes ---
	useEffect(() => {
		const loadProductLogs = async () => {
			setLoading(true);
			try {
				const res = await getProductLogs(
					scraperId,
					actionFilter,
					page + 1,
					rowsCount,
					scraper_run_id
				);
				setLogs(res.data.results.data);
				setCount(res.data.count);
			} catch (err) {
				console.error("Failed to fetch logs", err);
			}
			setLoading(false);
		};

		if (scraperId) {loadProductLogs();}
	}, [scraperId, actionFilter, page, rowsCount, scraper_run_id]);

	const handleChange = (event, newValue) => {
		const actionFilterArray = ["updated", "deactivated", "created"];
		setValue(newValue);
		setActionFilter(actionFilterArray[newValue - 1]);
		setPage(0); // reset page when filter changes
	};

	// --- Pagination handlers for MUIDataTable ---
	const handlePageChange = (newPage) => {
		setPage(newPage);
	};

	const handleRowsPerPageChange = (newRowsPerPage) => {
		setRowsCount(newRowsPerPage);
		setPage(0); // reset to first page
	};

	const handleSearchChange = async (searchText) => {
		// call your API to search logs
		console.log("SEARCH IS TRIGGERING");
		const res = await getProductLogs(
			scraperId,
			null,
			1,
			10,
			scraper_run_id,
			searchText // ✅ new
		);

		setLogs(res.data.results.data);

		setCount(res.data.count); // total count for pagination
	};

	useEffect(() => {
		const getProductCard = async () => {
			const res = await getScraperReportCards(scraper_run_id);
			setPercentageData(res.data);
		};

		getProductCard();
	}, [scraper_run_id]);

	return (
		<>
			<Toolbar>
				<Typography className={classes.title} variant="h4" noWrap>
					Product Logs
				</Typography>
			</Toolbar>
			<ToastContainer />

			{/* <Box
				sx={{
					display: "flex",
					gap: 2,
					mb: 3,
					flexWrap: "wrap",
					mx: 3,
				}}
			>
				<Box
					sx={{
						p: 2,
						borderRadius: 2,
						boxShadow: 1,
						minWidth: 200,
						textAlign: "center",
						backgroundColor: "#f5f5f5",
					}}
				>
					<Typography variant="subtitle2">
						Stock Updates (%)
					</Typography>
					<Typography variant="h6">
						{(
							(percentageData?.size_update_count /
								percentageData?.sum_of_playoffs_products) *
							100
						)?.toFixed(2)}
						%
					</Typography>

					<Typography variant="subtitle2">
						{percentageData?.size_update_count}/
						{percentageData?.sum_of_playoffs_products}
					</Typography>
				</Box>

				<Box
					sx={{
						p: 2,
						borderRadius: 2,
						boxShadow: 1,
						minWidth: 200,
						textAlign: "center",
						backgroundColor: "#f5f5f5",
					}}
				>
					<Typography variant="subtitle2">
						All Out of Stock (%)
					</Typography>
					<Typography variant="h6">
						{(
							(percentageData?.all_out_of_stock /
								percentageData?.sum_of_playoffs_products) *
							100
						)?.toFixed(2)}
						%
					</Typography>
					<Typography variant="subtitle2">
						{percentageData?.all_out_of_stock}/
						{percentageData?.sum_of_playoffs_products}
					</Typography>
				</Box>

				<Box
					sx={{
						p: 2,
						borderRadius: 2,
						boxShadow: 1,
						minWidth: 200,
						textAlign: "center",
						backgroundColor: "#f5f5f5",
					}}
				>
					<Typography variant="subtitle2">Price Drop (%)</Typography>
					<Typography variant="h6">
						{(
							(percentageData?.deceresed_product_price_count /
								percentageData?.sum_of_playoffs_products) *
							100
						)?.toFixed(2)}
						%
					</Typography>
					<Typography variant="subtitle2">
						{percentageData?.deceresed_product_price_count}/
						{percentageData?.sum_of_playoffs_products}
					</Typography>
				</Box>

				<Box
					sx={{
						p: 2,
						borderRadius: 2,
						boxShadow: 1,
						minWidth: 200,
						textAlign: "center",
						backgroundColor: "#f5f5f5",
					}}
				>
					<Typography variant="subtitle2">
						Price Increased (%)
					</Typography>
					<Typography variant="h6">
						{(
							(percentageData?.increased_product_price_count /
								percentageData?.sum_of_playoffs_products) *
							100
						)?.toFixed(2)}
						%
					</Typography>
					<Typography variant="subtitle2">
						{percentageData?.increased_product_price_count}/
						{percentageData?.sum_of_playoffs_products}
					</Typography>
				</Box>

				<Box
          sx={{
            p: 2,
            borderRadius: 2,
            boxShadow: 1,
            minWidth: 200,
            textAlign: "center",
            backgroundColor: "#f5f5f5",
          }}
        >
          <Typography variant="subtitle2">
            More than 3 sizes out of stock (%)
          </Typography>
          <Typography variant="h6">
            {(
              (percentageData?.all_out_of_stock /
                percentageData?.total_products) *
              100
            )?.toFixed(2)}
            %
          </Typography>
          <Typography variant="subtitle2">
            {percentageData?.all_out_of_stock}/{percentageData?.total_products}
          </Typography>
        </Box>
			</Box> */}
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<TabList
						onChange={handleChange}
						aria-label="lab API tabs example"
					>
						<Tab
							label={`Updated (${percentageData?.updated})`}
							value="1"
						/>
						<Tab
							label={`Out of Stock (${percentageData?.deactivated})`}
							value="2"
						/>
						<Tab
							label={`Created (${percentageData?.created})`}
							value="3"
						/>
					</TabList>
				</Box>
				{["1", "2", "3"].map((tabValue) => (
					<TabPanel key={tabValue} value={tabValue}>
						<ProductLogsTable
							logs={logs}
							loading={loading}
							page={page}
							rowsCount={rowsCount}
							count={count}
							handlePage={handlePageChange}
							handleRowsCount={handleRowsPerPageChange}
							handleSearchChange={handleSearchChange}
						/>
					</TabPanel>
				))}
			</TabContext>
		</>
	);
}

export default ProductLogs;
